import { Link } from "react-router-dom";
import { StoreHeader } from './StoreHeader';
import { StoreFooter } from './StoreFooter';
import { useEffect } from 'react';

export function AirFryerPlug() {

    useEffect(() => {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }, []);

  return (
    <article className="prose prose-stone max-w-3xl mx-auto px-4 py-8">
      {/* Header */}
      <StoreHeader />
      <header className="mb-6">
        <h1 className="text-3xl font-extrabold text-emerald-900 tracking-tight">
          Ndio Hii Air Fryer, Bro! 🍟🔥
        </h1>
        <p className="text-stone-600 italic">
          Megamart Plug — shopping tips with vibes, not lectures.
        </p>
      </header>

      {/* Intro */}
      <section className="mb-6">
        <p className="text-stone-800">
          Sasa imagine uko kwa nyumba, umeshinda na chips za kiosk kila siku.
          Then unaskia beshte wako anasema:
          <em>
            “Bro, kuna machine inaitwa air fryer, inakula mafuta kidogo lakini
            inatoa chips zinakaa za hotel!”
          </em>{" "}
          😳
        </p>
        <p className="text-stone-800">
          Unabaki hapo, <em>“Wee, si unacheza na mimi?”</em> Lakini kumbe ni
          legit. Karibu kwenye <strong>Megamart Plug</strong> — leo tunakufundisha
          vile air fryer ni life hack ya Nairobi kitchens.
        </p>
      </section>

      {/* How to Use */}
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-emerald-900">
          Jinsi ya Kutumia (How to Use)
        </h2>
        <ul className="list-disc pl-6 text-stone-800">
          <li>
            <strong>Preheat kidogo:</strong> Si unajua gari lazima iwarm up? Hii
            nayo ni hivyo.
          </li>
          <li>
            <strong>Usijaze basket hadi overflow:</strong> Chips zikibondeka
            hazitakuwa crispy, bro.
          </li>
          <li>
            <strong>Shake-shake katikati ya cooking:</strong> Kama DJ akichanganya
            track, ndio food ikuwe uniform.
          </li>
          <li>
            <strong>Experiment na settings:</strong> Fries, chicken, veggies —
            kila kitu iko na vibe yake.
          </li>
        </ul>
        <p className="text-stone-700 mt-3">
          <strong>Megamart Tip:</strong> Usisahau kucheck recipes zetu online,
          tunakupiga plug na ideas za haraka.
        </p>
      </section>

      {/* Care & Maintenance */}
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-emerald-900">Care &amp; Maintenance</h2>
        <ul className="list-disc pl-6 text-stone-800">
          <li>
            <strong>Osha mara moja:</strong> Usisubiri hadi ikuwe na mafuta kama
            jiko la mama mboga.
          </li>
          <li>
            <strong>Usitumie steel wool:</strong> Bro, hiyo ni kama ku-scratch
            screen ya iPhone na keys.
          </li>
          <li>
            <strong>Weka mahali safi:</strong> Si balcony yenye mvua inabisha,
            tafadhali.
          </li>
        </ul>
        <p className="text-stone-700 mt-3">
          <strong>Megamart Plug:</strong> Tunauza pia accessories za kusafisha —{" "}
          <Link
            to="/products?search=cleaning%20kit"
            className="text-red-600 hover:underline"
          >
            angalia catalog yetu
          </Link>
          .
        </p>
      </section>

      {/* Budget Options */}
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-emerald-900">Budget Options 💸</h2>
        <div className="grid md:grid-cols-3 gap-4">
          <div className="border border-stone-200 rounded-lg p-4">
            <h3 className="font-semibold text-stone-900">Chini ya 10K</h3>
            <p className="text-stone-700">
              Ndogo, perfect kwa bachelor pad. Basic controls, kazi ni safi.
            </p>
            <Link
              to="/products?search=air%20fryer%20under%2010000"
              className="text-red-600 hover:underline"
            >
              Browse options
            </Link>
          </div>
          <div className="border border-stone-200 rounded-lg p-4">
            <h3 className="font-semibold text-stone-900">10K–20K</h3>
            <p className="text-stone-700">
              Digital controls, presets za fries na chicken. Balance ya value na
              features.
            </p>
            <Link
              to="/products?search=air%20fryer%2010000%2020000"
              className="text-red-600 hover:underline"
            >
              Browse options
            </Link>
          </div>
          <div className="border border-stone-200 rounded-lg p-4">
            <h3 className="font-semibold text-stone-900">20K+ (Premium)</h3>
            <p className="text-stone-700">
              Smart air fryer, app control, multi-function. Hii ni ya wale mabazu.
            </p>
            <Link
              to="/products?search=premium%20air%20fryer"
              className="text-red-600 hover:underline"
            >
              Browse options
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="mb-10">
        <div className="bg-stone-50 border border-stone-200 rounded-xl p-6">
          <h3 className="text-xl font-bold text-emerald-900">
            Ready to Upgrade Your Kitchen?
          </h3>
          <p className="text-stone-800">
            Ukiwa unasema{" "}
            <em>“nataka kula healthy lakini sitaki kuumia kwa mafuta”</em>, air
            fryer ndio plug. <strong>Megamart</strong> iko na options zote —
            kutoka budget hadi premium.
          </p>
          <Link
            to="/products?search=air%20fryer"
            className="inline-block mt-3 bg-red-600 text-white px-5 py-2 rounded-md hover:bg-red-700"
          >
            Shop Air Fryers on Megamart.co.ke
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="pt-6 border-t border-stone-200">
        <p className="text-stone-600 text-sm">
          Megamart Plug: shopping tips, comparisons, and care guides — all with
          Nairobi flavor.{" "}
          <Link to="/the-plug" className="text-red-600 hover:underline">
            Discover more guides
          </Link>
          .
        </p>
      </footer>
      <StoreFooter />
    </article>
  );
}
